import { Cart, Monitor, Profile, RestaurantMenu } from '@popmenu/web-icons';

type Status = 'pending' | 'completed' | 'error';

export const SelfSignUpFeedbackEvent = {
  FiringUpYourOrder: 'firing_up_your_order',
  PreppingYourProfile: 'prepping_your_profile',
  SeasoningYourDesign: 'seasoning_your_design',
  ServingUpYourMyPopDashboard: 'serving_up_your_my_pop_dashboard',
} as const;

export type SelfSignUpFeedbackEvent = (typeof SelfSignUpFeedbackEvent)[keyof typeof SelfSignUpFeedbackEvent];

const initialStepManager: Record<SelfSignUpFeedbackEvent, Status> = {
  firing_up_your_order: 'pending',
  prepping_your_profile: 'pending',
  seasoning_your_design: 'pending',
  serving_up_your_my_pop_dashboard: 'pending',
} as const;

type Step = {
  event: SelfSignUpFeedbackEvent;
  icon: React.FC<React.SVGProps<SVGSVGElement>> | undefined;
};

const steps: Step[] = [
  {
    event: SelfSignUpFeedbackEvent.PreppingYourProfile,
    icon: Profile,
  },
  {
    event: SelfSignUpFeedbackEvent.FiringUpYourOrder,
    icon: Cart,
  },
  {
    event: SelfSignUpFeedbackEvent.SeasoningYourDesign,
    icon: RestaurantMenu,
  },
  {
    event: SelfSignUpFeedbackEvent.ServingUpYourMyPopDashboard,
    icon: Monitor,
  },
];

export const progressStepManagerOptions = {
  initialStepManager,
  shouldFakeResults: false,
  steps,
  timeoutPerStep: 3200,
};
